import { useEffect } from "react";
import utils from "./utils";

export const OptionRow = ({
  name,
  img,
  title,
  subtitle = null,
  price,
  min = null,
  valueChanged = null,
}) => {
  const handleValueChange = (e) => {
    valueChanged?.call(this, name, e.target.value);
  };

  const defaultVal = min || 0;

  useEffect(() => {
    valueChanged?.call(this, name, min || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, min]);

  return (
    <div className="option-row">
      <div className="image p-2">
        {img && <img src={img} alt={title} width={48} />}
      </div>
      <div className="title">
        <div className="maintitle font-bold">{title}</div>
        {subtitle && <div className="subtitle italic text-sm">{subtitle}</div>}
      </div>

      <div className="price">
        {utils.intToEuros(price.price)} / {price.per}
      </div>
      <div className="quantity" style={{ width: 100 }}>
        <input
          type="number"
          defaultValue={defaultVal}
          min={defaultVal}
          autoComplete="off"
          onChange={handleValueChange}
        />
      </div>
    </div>
  );
};
